import { render, staticRenderFns } from "./creditnote.vue?vue&type=template&id=57c32f3b&"
import script from "./creditnote.vue?vue&type=script&lang=ts&"
export * from "./creditnote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports